<template>
    <!-- ref="bannerContainer" -->
    <div class="ui-newHome-banner">

        <div
            :style="[{position:'relative'},{backgroundColor:bannerBgColor}]"
            :class="[isOpenActivity?'newHome-bg-content':'newHome-bg-noActivity']"
            v-if="newList && newList.length"
        >
            <div v-if="isOpenActivity">
                <img
                    class="newhome-img-hidden"
                    :src="ActivityBannerObj.bannerImgSrc"
                />
                <KPL
                    class="ui-kpl-bg"
                    :url="ActivityBannerObj.bannerImgURL"
                    :clstag="'jr|keycount|8530052_index_topbanner_big_'+ newIndex+'|'+title"
                    eventId="MInterestFree_TopBanner"
                    :eventParam="'banner_bg_'+String(newIndex)"
                    @upData='bannerUpData(newBannerUpdata)'
                >
                    <img
                        class="newhome-img"
                        :src="ActivityBannerObj.bannerImgSrc"
                        v-if="showBgBanner"
                    />
                </KPL>
            </div>
            <div
                v-else
                class="newHome-bg"
            >
            </div>
            <div
                :class="[isOpenActivity?'ui-banner':'bannerNoActivity']"
                ref="bannera"
            >
                <div class="ui-homebg">
                    <div class="ui-home-f">

                        <Slider
                            class="act-slide1"
                            style="z-index:999;"
                            :autoPlay="isLoop"
                            :loop="isLoop"
                            :data="newList"
                            :speed="600"
                            :showDots="true"
                            :slideDots="newList"
                            @scrollEnd="onScrollEnd"
                            ref="mychild"
                        >
                            <KPL
                                class="ui-kpl"
                                style="height: 100%!important;"
                                v-for="(item, index) in newList"
                                :key="index"
                                :url="item.url"
                                :clstag="'jr|keycount|8530052_index_topbanner_small_'+ index+'|'+item.title"
                                eventId="MInterestFree_TopBanner"
                                :eventParam="String(index)"
                                @upData='silderUpData(item)'
                            >
                                <div class="marTop"></div>
                                <a href="javascript:void(0);">
                                    <img
                                        class="act-banner1"
                                        :src="item.imgSrc"
                                        v-if="item.imgSrc"
                                    >
                                    <div class="ui-maskDiv"></div>
                                </a>
                            </KPL>
                        </Slider>
                    </div>
                </div>
            </div>
        </div>

        <div class="ui-home-banner">
            <div class="ui-flex">
                <NativeOpenWeb
                    clstag="jr|keycount|8530052_index_icon|lingquan"
                    :url="'https://m.jr.jd.com/mjractivity/rn/couponCenter/index.html?RN=couponCenter&tab=20'"
                    :jumpType="'12'"
                    :eventId="'MInterestFree_IconCoupon'"
                    :eventParam="'1'"
                >
                    <img :src="couponsRedemption" />
                    <p class="ui-text">领券</p>
                </NativeOpenWeb>
            </div>
            <div class="ui-flex">
                <NativeOpenWeb
                    clstag="jr|keycount|8530052_index_icon|baitiao"
                    :url="nav2Url"
                    :eventId="'MInterestFree_IconRebate'"
                    :eventParam="'1'"
                >
                    <img :src="nav2IconUrl" />
                    <p class="ui-text">{{nav2Title}}</p>
                </NativeOpenWeb>
            </div>
            <div class="ui-flex">
                <NativeOpenWeb
                    clstag="jr|keycount|8530052_index_icon|tie"
                    :url="nav3Url"
                    :eventId="'MInterestFree_IconQuota'"
                    :eventParam="'1'"
                >
                    <img :src="nav3IconUrl" />
                    <p class="ui-text">{{nav3Title}}</p>
                </NativeOpenWeb>
            </div>
            <div
                class="ui-flex"
                @click="showRedTip"
            >
                <NativeOpenWeb
                    clstag="jr|keycount|8530052_index_icon|hongbao"
                    :url="subject4Url"
                    :eventId="'MInterestFree_IconRights'"
                    :eventParam="'1'"
                >
                    <div style="width:2.5rem;height:2.5rem;margin:0 auto;position:relative;">
                        <img :src="subject4Icon" />
                        <div
                            v-if="isDue"
                            class="ui-redtip"
                        ></div>
                    </div>
                    <p class="ui-text">{{subject4Title}}</p>
                </NativeOpenWeb>
            </div>
        </div>
    </div>
</template>
<script>
import Slider from '@/components/Slider.vue';
import KPL from '@/buscomponents/KPL.vue';
import NativeOpenWeb from '@/buscomponents/NativeOpenWeb.vue';
import { isTimeOverdue, setTimeOverdue } from '@/util/storageDateLimt';
import request from '@/util/request';
import { getStaticConfig } from '@/util/common';
const staticDataSource = (window['data_source_100001014'] && window['data_source_100001014']) || {};
const subject = staticDataSource.subject; //免息红包
const raiseObject = staticDataSource.raiseLink || {};
const redemption = staticDataSource.getCoupon; //领券
const whiteTa = staticDataSource.whiteCoupons; //白条
let subject4 = {};
try {
    if (subject && subject[0]) {
        subject4 = subject[0] || {};
    }
} catch (error) {
    console.log(error);
}
export default {
    name: 'Banner',
    components: {
        Slider,
        KPL,
        NativeOpenWeb
    },
    data() {
        return {
            newList: [],
            bannerColor: '#fff',
            jdUrl: `https://bt.jd.com/v3/mobile/rGuide_initGuideMobileWXQQ?source=JD_xcx&channelName=194&returnUrl=${encodeURIComponent(window.location.origin + window.location.pathname)}`,
            newHomeBg: '',
            newUrl: '',
            title: '',
            newIndex: 0,
            nav2Title: '女神价到',
            nav2Url: 'https://pro.m.jd.com/mall/active/rAMzLduznsKLYkNBiK54WTjK42/index.html',
            nav2IconUrl: '//m.360buyimg.com/jfe/jfs/t1/33446/17/6532/2531/5cbe7434E7b441fd0/75a3a4e7b11c3b54.png',
            nav3Title: '赚钱',
            nav3Url: 'https://jddx.jd.com/m/jdd/money/index.html?from=h5',
            nav3IconUrl: '//m.360buyimg.com/jfe/jfs/t1/35700/33/3234/2662/5cbe779eE120366f5/f07dfab38df8b9b0.png',
            subject4Title: subject4.title,
            subject4Url: subject4.otherUrl,
            subject4Icon: subject4.imgSrc || '//m.360buyimg.com/jrqb/jfs/t27781/168/907716842/1062/c7e9912a/5bbc6097N76bde6ef.png',
            showBgBanner: false,
            isDue: true,
            vowLink: {},
            hasVowLink: false,
            newBannerUpdata: {}, //数据上报
            hasOpenLaiKe: false, //是否关闭来客接口
            couponsRedemption: redemption.imgSrc || '//m.360buyimg.com/jrqb/jfs/t24991/362/1785029769/1310/4ad6de95/5bbc60deN794d64e7.png' //领券的icon
        };
    },
    props: {
        list: {
            type: Array,
            default: () => {
                return [];
            }
        },
        isLoop: {
            type: Boolean,
            default: true
        },
        isOpenActivity: false,
        ActivityBannerObj: {},
        bannerBgColor: {
            type: String,
            default: '#000'
        }
    },
    computed: {
        bannerFadeIn() {
            return 'bannerFadeIn';
        }
    },
    created() {
        if ($.device && $.device.jdapp) {
            nav2Url = 'https://pro.m.jd.com/mall/active/2YFhKoZzdJ5cNjakF7sn7bYLkQ2s/index.html';
            nav3Url = 'https://jddx.jd.com/m/jdd/money/index.html?from=jd';
        }
        this.hasVowLink = getStaticConfig('hasVowLink');
        this.vowLink = getStaticConfig('vowLink');
        this.hasOpenLaiKe = getStaticConfig('hasOpenLaiKe');
    },
    methods: {
        //轮播上报数据
        silderUpData(item) {
            try {
                if (item && item.clickUrlList && item.clickUrlList.length) {
                    item.clickUrlList.forEach(list => {
                        $.ajax({
                            url: list,
                            success: () => {}
                        });
                    });
                }
            } catch (error) {}
        },
        //banner上报数据
        bannerUpData(item) {
            try {
                if (item && item.clickUrlList && item.clickUrlList.length) {
                    item.clickUrlList.forEach(list => {
                        $.ajax({
                            url: list,
                            success: () => {}
                        });
                    });
                }
            } catch (error) {}
        },
        onScrollEnd(index) {
            this.newUrl = this.newList[index].bannerImgURL;
            this.newHomeBg = this.newList[index].bannerImgSrc;
            this.title = this.newList[index].title;
            this.newIndex = index;
            this.showBgBanner = false;
            this.$nextTick(() => {
                this.showBgBanner = true;
            });
            this.newBannerUpdata = this.newList[index];
        },
        showRedTip() {
            if (this.isDue) {
                this.isDue = false;
                setTimeOverdue('everyday_red');
            }
        },
        //首页banner接来客
        getSelectedActivity() {
            const defer = window.jsBridgeV3.onReady();
            const selectedActivity = {};
            defer.then(res => {
                res.jsToGetResp(
                    d => {
                        d = typeof d == 'object' ? d : JSON.parse(d);
                        if (d.deviceInfo) {
                            selectedActivity.userAgent = $.device.jdPayClientName; //用户的浏览器类型，即HTTP请求头部的User-Agent
                            selectedActivity.language = ''; //用户的默认系统语言
                            selectedActivity.os = $.device.os ? $.device.os : ''; //操作系统
                            selectedActivity.osv = $.device.osVersion ? $.device.osVersion : ''; //系统版本
                            selectedActivity.orientation = 3; //用户设备的屏幕方向 1：竖屏； 2：横屏； 3：未知
                            selectedActivity.brand = d.deviceInfo.clientType ? d.deviceInfo.clientType : ''; //硬件品牌
                            selectedActivity.hwv = d.deviceInfo.osPlatform ? d.deviceInfo.osPlatform : ''; //设备硬件版本
                            selectedActivity.operator = 0; //设备的网络运营商
                            selectedActivity.network = 0; //0-未识别，1-wifi，2-2g，3-3g，4-4g
                            selectedActivity.h = window.screen.height; //屏幕高度
                            selectedActivity.w = window.screen.width; //屏幕宽度
                            selectedActivity.deviceSize = $.device.screen ? $.device.screen : ''; //屏幕分辨率
                            selectedActivity.lon = d.deviceInfo.longitude ? d.deviceInfo.longitude : ''; //经度
                            selectedActivity.lat = d.deviceInfo.latitude ? d.deviceInfo.latitude : ''; //纬度
                            selectedActivity.mac = $.device.mac ? $.device.mac : ''; //用户设备的mac地址
                            selectedActivity.locationInfo = d.deviceInfo.city ? d.deviceInfo.city : ''; //位置信息
                            if ($.device.clientType === 'android') {
                                selectedActivity.androidId = d.deviceInfo.UUID ? d.deviceInfo.UUID : ''; //对于安卓设备设置安卓id。ios不填
                                selectedActivity.deviceId = d.deviceInfo.deviceId ? d.deviceInfo.deviceId : ''; //用户设备唯一标识 ，ios-idfa，安卓-imei
                                selectedActivity.ip = d.deviceInfo.IPAddress1 ? d.deviceInfo.IPAddress1 : '';
                            }
                            if ($.device.clientType === 'ios') {
                                selectedActivity.deviceId = d.deviceInfo.IDFA ? d.deviceInfo.IDFA : '';
                                selectedActivity.ip = '10.13.61.73';
                            }
                            if (d.terminalType) {
                                //设备平台（ e.g., " 0手机 ，1平板 ，3电视 "）
                                selectedActivity.deviceType = d.deviceInfo.terminalType.substr(1);
                            } else {
                                selectedActivity.deviceType = '';
                            }
                            request.selectedActivity({
                                data: {
                                    userDeviceInfo: selectedActivity
                                },
                                success: rstData => {
                                    this.$loading.hide();
                                    if (rstData && rstData.bannerList && rstData.bannerList.length) {
                                        let _item = rstData.bannerList[0];
                                        // this.list.splice(this.list.length, 1, _item);
                                        this.list.splice(3, 0, _item);
                                        this.$set(this, 'list', this.list);
                                        this.$refs.mychild.update();
                                        if (_item.showUrlList && _item.showUrlList.length) {
                                            try {
                                                _item.showUrlList.forEach(list => {
                                                    $.ajax({
                                                        url: list,
                                                        success: () => {}
                                                    });
                                                });
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }
                                    }
                                },
                                afterError: res => {
                                    console.log(res);
                                    this.$loading.hide();
                                }
                            });
                        }
                    },
                    {
                        type: 9,
                        //isLocation—是否要获取定位信息,原生默认为true
                        isLocation: true,
                        data: ''
                    }
                );
            });
        }
    },
    mounted() {
        this.isDue = isTimeOverdue('everyday_red');
        if ($.device && $.device.jdjr) {
            if (this.hasOpenLaiKe) {
                setTimeout(() => {
                    this.getSelectedActivity();
                }, 300);
            }
        }
    },
    watch: {
        // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
        list: {
            handler(val) {
                this.newList = val;
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.onScrollEnd(0);
                    });
                }, 10);
            },
            deep: true
        }
    },

    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.ui-newHome-banner {
    padding-bottom: $rem20;
    .newHome-bg-content {
        min-height: 300px;
        overflow: hidden;
    }
    .newHome-bg-noActivity {
        // min-height: $rem450;
        // max-height: $rem520;
        min-height: $rem360;
        overflow: hidden;
    }
    .newHome-bg {
        position: relative;
        height: 100%;
    }

    .ui-homebg {
        background-size: 100% $rem50;
        background-image: url('//m.360buyimg.com/jrqb/jfs/t1/4411/17/9022/734/5bab470bE24093fbd/467c6a2650b69ed8.png');
        background-position: bottom;
        background-repeat: no-repeat;
        height: auto;
    }
    .ui-redtip {
        position: absolute;
        right: $rem10;
        top: $rem8;
        background: #ee3d51;
        border-radius: 50%;
        width: $rem20;
        height: $rem20;
    }
    .ui-home-f {
        // background-size: 100% 10%;
        background-position: bottom;
        padding: 0 $rem42 $rem57 $rem42;
        width: 100%;
    }
    .act-slide1 {
        height: auto !important;
        top: $rem36;
        a {
            height: 100%;
            img {
                width: 100%;
                background: #cad3e4;
                box-shadow: 0 10px 20px 0 rgba(11, 19, 43, 0.24);
            }
        }
    }
    .ui-home-banner {
        width: 100%;
        display: flex;
        height: $rem190;
        background: #ffffff;
        font-size: $rem24;
        color: #333333;
        text-align: center;
        padding: $rem32 $rem16 $rem32 $rem16;
    }
    .ui-flex {
        flex: 1;
        img {
            width: $rem80;
            height: $rem80;
        }
    }
    .act-banner1 {
        // height: 100%;
        width: 100%;
    }
    .ui-kpl {
        // box-shadow: 0 4px 3px 0 rgba(11,19,43,0.1);
    }

    .ui-kpl-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .ui-banner {
        width: 100%;
        // min-height: 264px;
        position: absolute;
        bottom: -1px;
        z-index: 9;
    }
    .ui-bannerNoActivity {
        width: 100%;
        bottom: -1px;
        z-index: 9;
    }

    .ui-text {
        padding-top: $rem10;
        font-size: $rem26;
        color: #333333;
    }
    .newhome-img {
        width: 100%;
    }
    .newhome-img-hidden {
        width: 100%;
        visibility: hidden;
    }
    .ui-newHomeNum {
        top: 2rem;
        right: 1rem;
        z-index: 9999;
        color: #ffffff;
        // color: red;
        text-align: right;
        position: relative;
    }
    .ui-newHomeIndex {
        font-size: $rem40;
    }
    .ui-newHomeSum {
        font-size: $rem26;
    }
    .ui-newHomeLine {
        font-size: $rem35;
    }

    .bannerFadeIn-enter-active {
        transition-timing-function: ease-in;
        transition: opacity 0.3s;
    }

    .bannerFadeIn-enter {
        opacity: 0;
    }
}

@media screen and (min-width: 330px) and (max-width: 400px) {
    .ui-newHome-banner {
        .newHome-bg-content {
            min-height: 370px;
        }
    }
}
.marTop {
    height: $rem60;
}
</style>
